import { render } from "./index.vue?vue&type=template&id=40f9be1a"
import script from "./index.vue?vue&type=script&lang=jsx"
export * from "./index.vue?vue&type=script&lang=jsx"

import "./index.vue?vue&type=style&index=0&id=40f9be1a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__